export const withDefaultHeaders = (getDefaultHeaders, requestFunction) => (requestParams, errorToFailureHash) => {
    const defaultHeaders = getDefaultHeaders();
    const headersOverriden = requestParams.headers
        ? Object.fromEntries(requestParams.headers)
        : {};
    const newRequestParams = Object.assign(Object.assign({}, requestParams), { headers: (requestParams.headers || []).concat(defaultHeaders.filter(([header]) => !headersOverriden[header])) });
    return requestFunction(newRequestParams, errorToFailureHash);
};
//# sourceMappingURL=with_default_headers.js.map